// Thin GA4 wrapper. Safe to call before gtag has loaded — events queue on dataLayer.
const GA_ID = "G-3FJ7GNHS9X";

const isBrowser = typeof window !== "undefined";

export const trackPageview = (path, title) => {
  if (!isBrowser || typeof window.gtag !== "function") return;
  window.gtag("event", "page_view", {
    page_path: path,
    page_title: title || document.title,
    page_location: window.location.href,
    send_to: GA_ID,
  });
};

export const trackEvent = (name, params = {}) => {
  if (!isBrowser || typeof window.gtag !== "function") return;
  window.gtag("event", name, { send_to: GA_ID, ...params });
};

// Conversion-style helpers (named so dashboards stay clean)
export const trackCTA = (label, location) =>
  trackEvent("cta_click", { cta_label: label, cta_location: location });

export const trackWhatsApp = (location) =>
  trackEvent("whatsapp_click", { source: location });

export const trackLeadSubmit = (product) =>
  trackEvent("lead_submit", { product: product || "unknown" });
